import { useMemo } from "react";
import { useApi, apiResolver } from "@/api/useApi";
import {
  TicketEvaluationResponse,
  TicketInsightsResponse,
} from "./TicketView.model";

export function useTicketViewApi() {
  const { api } = useApi();

  return useMemo(
    () => ({
      getTicketInsights: (ticketId: string) =>
        apiResolver<TicketInsightsResponse>(
          api.get(`platform/ticket-view/${ticketId}/insights`)
        ),
      getTicketEvaluation: (ticketId: string) =>
        apiResolver<TicketEvaluationResponse>(
          api.get(`platform/ticket-view/${ticketId}/evaluation`)
        ),
    }),
    [api]
  );
}
